import { useQueryClient } from '@tanstack/react-query';

import { getStreamTokenOptions } from '@/features/chat/hooks/useGetStreamToken';

export function useTokenProvider() {
  const queryClient = useQueryClient();
  return async () => {
    const { token } = await queryClient.fetchQuery(getStreamTokenOptions());
    return token.value;
  };
}
